import type { TemplateListItem } from '@/lib/templates/types/template-list-item'

/**
 * Client-side AND-match filter, mirroring `filterBackgroundsByKeywords` exactly: every selected
 * keyword must be present on the item. No endpoint takes a keyword param (see
 * `templates.service.ts`) — a customer template's `keywordIds` is always `[]`
 * (`normalizeCustomerTemplate`), so Custom Templates correctly returns zero results once any
 * keyword filter is active.
 */
export function filterTemplatesByKeywords(
  templates: TemplateListItem[],
  selectedKeywordIds: readonly string[]
): TemplateListItem[] {
  if (selectedKeywordIds.length === 0) return templates

  return templates.filter((template) => {
    const templateKeywordIds = new Set(template.keywordIds)

    return selectedKeywordIds.every((id) => templateKeywordIds.has(id))
  })
}
